import React, { CSSProperties } from 'react';

import SaralLoaderImage from '../SaralLoaderImage';

interface MainFallbackLoaderProps {
  style?: CSSProperties;
  className?: string;
}

const MainFallbackLoader: React.FC<MainFallbackLoaderProps> = ({ style, className }) => {
  return (
    <div className={`saral-main-loader ${className || ''}`.trim()} style={style}>
      <SaralLoaderImage />
    </div>
  );
};

export default MainFallbackLoader;
